import { styled } from '@mui/material/styles';
import { Box, MenuItem, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import TextSearch from '../../controls/TextSearch';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Client } from '../../../data/models/client.model';
import { useCommonTranslation } from '../../../hooks/useCommonTranslation';

const PREFIX = 'SearchToolbar';

const classes = {
  container: `${PREFIX}-container`,
  toolbar: `${PREFIX}-toolbar`,
  search: `${PREFIX}-search`,
  dropdown: `${PREFIX}-dropdown`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(3),
    gap: theme.spacing(1),
  },

  [`& .${classes.toolbar}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },

  [`& .${classes.search}`]: {
    flexGrow: 1,
    minWidth: 500,
    maxWidth: 600,
  },

  [`& .${classes.dropdown}`]: {
    minWidth: 300,
    backgroundColor: '#fff',
  },
}));

interface SearchToolbarProps {
  clients: Client[];
  currentClientBC: string;
  currentSearchText: string;
  isPortal: boolean;
  onClientChange: (val: string | null) => void;
  onSearchTextChange: (val: string) => void;
  // onCreatePassenger: () => void;
}

export default function SearchToolbar({
  clients,
  currentClientBC,
  currentSearchText,
  isPortal,
  onClientChange,
  onSearchTextChange,
}: SearchToolbarProps) {
  const t = useCommonTranslation();

  return (
    <StyledBox className={classes.container}>
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <Box className={classes.toolbar}>
          {!isPortal && (
            <TextField
              className={classes.dropdown}
              select
              label={t('passenger.selectClient')}
              variant="outlined"
              required={true}
              value={currentClientBC}
              onChange={(evt) => onClientChange(evt.target.value)}>
              {clients?.map((client) => {
                return (
                  <MenuItem value={client.clientBC} key={client.clientBC}>
                    {client.legalName}
                  </MenuItem>
                );
              })}
            </TextField>
          )}
          <Box className={classes.search}>
            <TextSearch
              id="text-search"
              icon={<SearchIcon />}
              label={t('passenger.search')}
              placeholder={t('passenger.searchPlaceholder')}
              currentSearchFilter={currentSearchText}
              disabled={!currentClientBC}
              onSearchChange={onSearchTextChange}></TextSearch>
          </Box>
        </Box>
      </LocalizationProvider>
    </StyledBox>
  );
}
